// extracted by mini-css-extract-plugin
export default {"cv":"CV_cv__4lzJH","iframe":"CV_iframe__WiC1j","buttonAdditional":"CV_buttonAdditional__JF9Oq"};